import { graphql, useStaticQuery } from 'gatsby';
import { IProduct } from '../types';

export type IProductsData = {
  posts: {
    edges: {
      node: IProduct;
    }[];
  };
};

const useProductsData = (slug: string) => {
  const data: IProductsData = useStaticQuery(graphql`
    {
      posts: allStoryblokEntry(filter: { field_component: { eq: "product" } }) {
        edges {
          node {
            id
            uuid
            name
            slug
            full_slug
            content
            created_at
          }
        }
      }
    }
  `);

  const desiredOrder = [
    '53a35eb3-6af8-4880-ac98-7483018b167f',
    'f796013b-b002-4119-a199-249d66785088',
    '3e5f7887-aa8e-4478-be24-00baa2809ae4',
  ]; // Replace with your actual UUIDs in the desired order

  // If slug is null or an empty string, return all products that start with "product"
  if (slug === null || slug === '') {
    const rawData = data.posts.edges
      .map((edge: any) => edge.node)
      .filter((node: any) => node.full_slug.startsWith('product'));

    return rawData.sort((a: any, b: any) => {
      return desiredOrder.indexOf(a.uuid) - desiredOrder.indexOf(b.uuid);
    });
  }
  const languagePrefix = slug.split('/')[1] || '';

  // Filter products by the current language context
  const filteredProducts = data.posts.edges
    .map((edge: any) => edge.node)
    .filter((node: any) => {
      if (languagePrefix) {
        return node.full_slug.startsWith(`${languagePrefix}/`);
      } else {
        return node.full_slug.startsWith('product').sort((a: any, b: any) => {
          return desiredOrder.indexOf(a.uuid) - desiredOrder.indexOf(b.uuid);
        });
      }
    });

  // Sort the filtered products based on the desired order
  const sortedProducts = filteredProducts.sort((a: any, b: any) => {
    return desiredOrder.indexOf(a.uuid) - desiredOrder.indexOf(b.uuid);
  });

  return sortedProducts;
};

export default useProductsData;
